import * as React from 'react'

export function useResizeObserver<T extends Element>(
  ref: React.RefObject<T | null> | undefined,
  callback: (rect: DOMRectReadOnly) => void,
) {
  React.useEffect(() => {
    const currentElement = ref?.current
    if (!currentElement) {
      return
    }

    const observer = new ResizeObserver(entries => {
      callback(entries[0].contentRect)
    })

    observer.observe(currentElement)
    callback(currentElement.getBoundingClientRect())

    return () => {
      observer.unobserve(currentElement)
    }
  }, [ref, callback])
}
